import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Menu, MenuMode } from '@bettercomp/ui-components';
import { useNavigationConfig } from './navigationConfig';

type NavMenuProps = {
  mode?: MenuMode;
  onClick?: () => void;
  className?: string;
}

export const NavMenu = ({ mode = MenuMode.Horizontal, onClick, className }: NavMenuProps) => {
  const router = useRouter();
  const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

  const navigationConfig = useNavigationConfig();

  useEffect(() => {
    navigationConfig.forEach((item: any) => {
      if (item.children) {
        item.children.forEach((child: any) => {
          if (router.pathname === child.key) {
            setSelectedKeys([item.key, child.key]);
          }
        })
      } else {
        if (router.pathname === item.key) {
          setSelectedKeys([item.key]);
        }
      }

    });
  }, [navigationConfig, router]);

  const navigate = (item: any) => {
    if (item.key) {
      router.push(item.key);
    }
    if (onClick) {
      onClick();
    }
  };

  return (
    <div className={className} data-testid="navMenu">
      <Menu
        mode={mode}
        selectedKeys={selectedKeys}
        onClick={navigate}
        items={navigationConfig}
      />
    </div>
  );
};
